"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const filterNumber = ({ _eq, _gt, _lt }, value) => {
    if (_eq) {
        return ramda_1.equals(_eq, value);
    }
    if (_lt) {
        return value < _lt;
    }
    if (_gt) {
        return value > _gt;
    }
    return false;
};
exports.vlNumberFilter = {
    name: "VLNumberFilter",
    sdl: `
    input VLNumberFilter {
      _eq: VLNumber
      _gt: VLNumber
      _lt: VLNumber
    }
  `,
    filterFunction: filterNumber,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVtYmVyRmlsdGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jbXMvZmlsdGVycy9udW1iZXJGaWx0ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQStCO0FBUy9CLE1BQU0sWUFBWSxHQUFHLENBQUMsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBa0IsRUFBRSxLQUFhLEVBQUUsRUFBRTtJQUN4RSxJQUFJLEdBQUcsRUFBRTtRQUNQLE9BQU8sY0FBTSxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQztLQUMzQjtJQUNELElBQUksR0FBRyxFQUFFO1FBQ1AsT0FBTyxLQUFLLEdBQUcsR0FBRyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxHQUFHLEVBQUU7UUFDUCxPQUFPLEtBQUssR0FBRyxHQUFHLENBQUM7S0FDcEI7SUFDRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMsQ0FBQztBQUVXLFFBQUEsY0FBYyxHQUF5QztJQUNsRSxJQUFJLEVBQUUsZ0JBQWdCO0lBQ3RCLEdBQUcsRUFBRTs7Ozs7O0dBTUo7SUFDRCxjQUFjLEVBQUUsWUFBWTtDQUM3QixDQUFDIn0=